// moment Timezone related
import momentTimezones from 'moment-timezone';
export const timezones = momentTimezones;
// export const timezonesName = momentTimezones.tz.names();
// export const timezonesGuess = momentTimezones.tz.guess();

// country list
const { getNames } = require('country-list');
export const countryList = getNames();